import { render, staticRenderFns } from "./salesRanki.vue?vue&type=template&id=633228c9&scoped=true"
import script from "./salesRanki.vue?vue&type=script&lang=js"
export * from "./salesRanki.vue?vue&type=script&lang=js"
import style0 from "./salesRanki.vue?vue&type=style&index=0&id=633228c9&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "633228c9",
  null
  
)

export default component.exports